export const GoogleTagManagerName = "contents-calc-unsaved-changes-popup-content";
export const GoogleTagManagerEvent = "pop_up";
export const GoogleTagManagerPopUpOpenAction = "open";
export const GoogleTagManagerSubmittedAction = "continue_calc";
export const GoogleTagManagerPopUpCloseAction = "exit";
